var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404Pattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 339,
    viewBox: "0 0 217 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4238 285.311L78.3971 250.758L106.736 254.739L111.111 224.35",
    stroke: "#E9FBEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.188 169.499L137.834 153.243L151.116 170.929L170.154 156.632L184.795 176.128",
    stroke: "#E9FBEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.917 148.038L201.277 208.049",
    stroke: "#E9FBEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.303 120.596L195.961 125.045",
    stroke: "#E9FBEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.562 297.351L143.822 301.463",
    stroke: "#E9FBEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.247 239.237L234.178 248.358",
    stroke: "#E9FBEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.725 264.259C141.204 266.903 140.486 271.891 143.122 275.401C145.757 278.911 150.748 279.612 154.269 276.968C157.79 274.324 158.508 269.335 155.872 265.826C153.237 262.316 148.246 261.614 144.725 264.259Z",
    fill: "#E9FBEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Pattern);
export default __webpack_public_path__ + "static/media/404Pattern.73f15fb348f682f010119a6ea173760d.svg";
export { ForwardRef as ReactComponent };